export default __webpack_public_path__ + "static/media/icon-tick.0782238c.svg";